import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTypedSelector } from '../../../stores';

const AuthGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isLoggedIn } = useTypedSelector(s => s.auth);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/sign-in', {
        state: {
          from: location.pathname
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return (
    <>
      {children}
    </>
  );
};

export default AuthGuard;
